import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafeVault = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M7 22C6.448 22 6 21.552 6 21V11C6 10.448 6.448 10 7 10C7.552 10 8 10.448 8 11V21C8 21.552 7.552 22 7 22Z" />
		<path d="M25 6H7C4.243 6 2 8.243 2 11V21C2 23.415 3.721 25.435 6 25.899V27C6 27.552 6.448 28 7 28C7.552 28 8 27.552 8 27V26H24V27C24 27.552 24.448 28 25 28C25.552 28 26 27.552 26 27V25.899C28.279 25.434 30 23.414 30 21V11C30 8.243 27.757 6 25 6ZM28 21C28 22.654 26.654 24 25 24H7C5.346 24 4 22.654 4 21V11C4 9.346 5.346 8 7 8H25C26.654 8 28 9.346 28 11V21Z" />
		<path d="M21.445 18.03C21.797 17.434 22 16.74 22 16C22 15.26 21.797 14.565 21.444 13.97L23.707 11.707C23.888 11.526 24 11.276 24 11C24 10.448 23.552 10 23 10C22.724 10 22.474 10.112 22.293 10.293L20.03 12.556C19.434 12.204 18.74 12 18 12C17.26 12 16.565 12.203 15.97 12.556L13.707 10.293C13.526 10.112 13.276 10 13 10C12.448 10 12 10.448 12 11C12 11.276 12.112 11.526 12.293 11.707L14.556 13.97C14.204 14.566 14 15.26 14 16C14 16.74 14.203 17.435 14.556 18.03L12.293 20.293C12.112 20.474 12 20.724 12 21C12 21.552 12.448 22 13 22C13.276 22 13.526 21.888 13.707 21.707L15.97 19.444C16.566 19.796 17.26 20 18 20C18.74 20 19.435 19.797 20.03 19.444L22.293 21.707C22.474 21.888 22.724 22 23 22C23.552 22 24 21.552 24 21C24 20.724 23.888 20.474 23.707 20.293L21.445 18.031V18.03ZM16 16C16 14.897 16.897 14 18 14C19.103 14 20 14.897 20 16C20 17.103 19.103 18 18 18C16.897 18 16 17.103 16 16Z" />
	</svg>
);

export default SafeVault;
